var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPfeilRechts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-1,.cls-2{stroke-width:0px;}.cls-3{opacity:.75;}.cls-2{fill:#b70d7f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Polygon_6-2",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.14,27.47c1.83,1.24,2.3,3.73,1.06,5.56-.28.42-.64.77-1.06,1.06L7.25,60.53c-1.83,1.24-4.31.77-5.56-1.06-.45-.66-.69-1.45-.69-2.25V4.33c0-2.21,1.79-4,4-4,.8,0,1.59.24,2.25.69l38.89,26.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.89,30.77c0-.2-.06-.57-.44-.83L5.56,3.5c-.43-.29-.83-.16-1.03-.06-.2.11-.53.36-.53.88v52.89c0,.52.33.78.53.88.2.11.6.24,1.03-.06l38.89-26.44c.38-.26.44-.63.44-.83M47.89,30.77c0,1.26-.58,2.51-1.75,3.31L7.25,60.53c-2.66,1.81-6.25-.1-6.25-3.31V4.33C1,1.12,4.59-.78,7.25,1.02l38.89,26.44c1.17.79,1.75,2.05,1.75,3.31Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfeilRechts);
export default __webpack_public_path__ + "static/media/Pfeil_rechts.2602bd202f48e5d1ade8c266296f7beb.svg";
export { ForwardRef as ReactComponent };